export default __webpack_public_path__ + "static/media/pexels-cottonbro_smilingKids.c91905cd.jpg";